import React, { useState } from 'react';
import firebase from 'firebase';

import Button from '../UI/button/Button';
import { db,storage } from '../../config/firebase';

import './Upload.css';

const Upload = () => {

    const [ caption, setCaption ] = useState("");
    const [ image, setImage ] = useState(null);
    const [ title, setTitle ] = useState("");
    const [ graphics, setGraphics] = useState(null);
    const [ progress, setProgress ] = useState(0);
    const [ videoKey, setVideoKey ] = useState("");
    const [ videoTitle, setVideoTitle ] = useState("");
    const [ type, setType ] = useState("image");

    const handleImageChange = (event) => {
        if(event.target.files[0]){
            setImage(event.target.files[0]);
        }
    }

    const handleGraphicsChange = (event) => {
        if(event.target.files[0]){
            setGraphics(event.target.files[0]);
        }
    }

    const videoUploadHandler = (event) => {
        event.preventDefault();
        db.collection('videos').add({
            timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            videoKey,
            videoTitle
        })
        .catch(err => alert(err));

        setVideoTitle("");
        setVideoKey("");
    }

    const imageUploadHandler = (event) => {
        event.preventDefault();
        if(!image){
            alert("Attach image");
            return;
        }
        const uploadTask = storage.ref(`images/${image.name}`).put(image);

        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = Math.round(
                    (snapshot.bytesTransferred/snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                console.log(error);
                alert(error.message)
            }, 
            () => {
                storage
                .ref("images")
                .child(image.name)
                .getDownloadURL()
                .then(url => {
                    db.collection('images').add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption:caption,
                        image: url,
                        title
                    })
                    setProgress(0);
                    setCaption("");
                    setImage(null);
                    setTitle("");
                })
            }
        )
    }

    const graphicsUploadHandler = (event) => {
        event.preventDefault();
        if(!graphics){
            alert("Attach image");
            return;
        }
        const uploadTask = storage.ref(`graphics/${graphics.name}`).put(graphics);
        
        uploadTask.on(
            "state_changed",
            (snapshot) => {
                const progress = Math.round(
                    (snapshot.bytesTransferred/snapshot.totalBytes) * 100
                );
                setProgress(progress);
            },
            (error) => {
                console.log(error);
                alert(error.message)
            }, 
            () => {
                storage
                .ref("graphics")
                .child(graphics.name)
                .getDownloadURL()
                .then(url => {
                    db.collection('graphics').add({
                        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
                        caption:caption,
                        image: url,
                        title
                    })
                    setProgress(0);
                    setCaption("");
                    setGraphics(null);
                    setTitle("");
                })
            }
        )
    }

    const imageUpload = (
        <React.Fragment>
            <form onSubmit={imageUploadHandler}>
                <progress className="upload-progress" value={progress} max="100" /> <br/>
                <input className="upload-input"
                placeholder="Caption"
                required
                type="text"
                value={caption}
                onChange={(e) => setCaption(e.target.value)} /> <br/>

                <input className="upload-input"
                placeholder="Title"
                required
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)} /> <br/>
    

                <input className="upload-input"
                type="file"
                onChange={handleImageChange} /> <br />
    
                <Button type="submit">Upload</Button>
            </form>
        </React.Fragment>
    );

    const graphicsUpload = (
        <React.Fragment>
            <form onSubmit={graphicsUploadHandler}>
                <progress className="upload-progress" value={progress} max="100" /> <br/>
                <input className="upload-input"
                placeholder="Caption"
                required
                type="text"
                value={caption}
                onChange={(e) => setCaption(e.target.value)} /> <br/>

                <input className="upload-input"
                placeholder="Title"
                required
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)} /> <br/>
    
                <input className="upload-input"
                type="file"
                onChange={handleGraphicsChange} /> <br />
    
                <Button>Upload</Button>
            </form>
        </React.Fragment>
    );

    const videoUpload = (
        <React.Fragment>
            <form onSubmit={videoUploadHandler}>
                <input className="upload-input"
                placeholder="Key"
                required
                type="text"
                value={videoKey}
                onChange={(e) => setVideoKey(e.target.value)} /> <br/>
    
                <input className="upload-input"
                placeholder="Title"
                required
                type="text"
                value={videoTitle}
                onChange={(e) => setVideoTitle(e.target.value)} /> <br/>
    
                <Button type="submit">Upload</Button>
            </form>
        </React.Fragment>
    );
    
    let formDisplay;
    if(type === 'image'){
        formDisplay = imageUpload;
    } else if(type === 'video'){
        formDisplay = videoUpload;
    } else if(type === 'graphics'){
        formDisplay = graphicsUpload;
    }

    //console.log(type);
    return (
        <div className="upload container">
            <p className="upload-title">UPLOAD</p>
            <select className="upload-dropdown" onChange={(e) => setType(e.target.value)}>
                <option value="image">Image</option>
                <option value="video">Video</option>
                <option value="graphics">Graphics</option>
            </select> <br/>
            <hr />
            {formDisplay}
        </div>
    );
};

export default Upload;


// WEBPACK FOOTER //
// ./src/components/upload/Upload.js